import { forwardRef } from "react";
import { Input } from "@/components/input";
import { ValidationWrapper } from "@/components/validation-wrapper";
import { InputValidatedProps } from "./types";

export const InputValidated = forwardRef<HTMLInputElement, InputValidatedProps>(
  ({ errorMessage, successMessage, helperMessage, ...props }, ref) => {
    const validationProps = { errorMessage, successMessage, helperMessage };

    return (
      <ValidationWrapper {...validationProps}>
        <Input ref={ref} {...props} />
      </ValidationWrapper>
    );
  },
);
